module.exports = __webpack_public_path__ + "static/media/jabrush.73c95bc6.TTF";


//////////////////
// WEBPACK FOOTER
// ./src/libs/fonts/jabrush.TTF
// module id = 156
// module chunks = 0